import { AppError } from './AppError';

/**
 * Represents an error for when an action cannot be completed because it conflicts
 * with the current state of the resource (e.g., creating a user that already exists).
 * Corresponds to an HTTP 409 Conflict status.
 */
export class ConflictError extends AppError {
  constructor(message: string = 'A conflict occurred with an existing resource', details?: any, options?: ErrorOptions) {
    super(message, 409, details, options);
  }
}
